<template>
  <div class="row">
    <b-card class="col-12" no-body>
      <div class="row">
        <div class="col-12 mb-3">
          <b-button variant="primary" @click="create" v-if="permissao.c">{{
            $t("GERAL.NOVO")
          }}</b-button>
        </div>
        <b-form class="col-12" @submit="onSearch">
          <div class="row">
            <filtro-empresas
              class="col-12 col-md-4"
              v-if="ehAdmin"
              @update="listar()"
            />
            <input-text
              :class="`col-12 col-md-${ehAdmin ? 8 : 12}`"
              label="Filtrar"
              placeholder="Digite o título para buscar..."
              v-model="filtro"
            >
              <template #append>
                <b-button variant="primary" class="ml-2" type="submit"
                  >Buscar</b-button
                >
              </template>
            </input-text>
          </div>
        </b-form>

        <div class="col-12">
          <b-table
            id="table"
            @row-dblclicked="open"
            head-variant="dark"
            hover
            :items="tabela.items"
            :fields="tabela.colunas"
          >
            <template #cell(col1)="data">
              <div class="row">
                <div class="col-12 mb-2 d-flex">
                  <b-badge
                    pill
                    class="px-2 py-1"
                    :variant="
                      retornarStatus(data.item.statusExecutora).variante
                    "
                  >
                    {{ retornarStatus(data.item.statusExecutora).text }}
                  </b-badge>
                  <b-badge
                    pill
                    class="px-2 py-1 ml-2"
                    variant="danger"
                    v-if="data.item.congelada"
                  >
                    <i :class="`fa-solid fa-lock mr-2`"></i>
                    Proposta congelada
                  </b-badge>
                </div>
                <Label
                  class="col-12"
                  label="Titulo:"
                  :value="data.item.descricaoTecnica.titulo"
                  icon="title"
                />
                <Label
                  class="col-12"
                  label="Apelido:"
                  :value="data.item.descricaoTecnica.apelido"
                  icon="subtitles"
                />
                <div class="col-12 col-md-6">
                  <div class="row">
                    <Label
                      class="col-12"
                      label="Executora:"
                      :value="
                        data.item.empresa ? data.item.empresa.nomeFantasia : ''
                      "
                      icon="apartment"
                    />
                    <Label
                      class="col-12"
                      label="Proponente:"
                      :value="data.item.proponente"
                      icon="business"
                    />
                    <Label
                      class="col-12"
                      label="Fase de inovação:"
                      :value="
                        (options.fases.find(
                          (el) =>
                            el.value ==
                            data.item.descricaoTecnica.faseDeInovacao
                        ) || {}).text || ''
                      "
                      icon="checklist_rtl"
                    />
                    <Label
                      class="col-12"
                      label="Tipo de produto:"
                      :value="
                        options.tipoProdutos.find(
                          (el) =>
                            el.value == data.item.descricaoTecnica.tipoProduto
                        ).text || ''
                      "
                      icon="category"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <Label
                    class="col-12"
                    label="Duração:"
                    :value="data.item.descricaoTecnica.duracao"
                    icon="timer"
                  />
                  <Label
                    class="col-12"
                    label="Segmento:"
                    :value="
                      options.segmentos.find(
                        (el) => el.value == data.item.descricaoTecnica.segmento
                      ).text || ''
                    "
                    icon="segment"
                  />
                  <Label
                    class="col-12"
                    label="Tema:"
                    :value="
                      data.item.descricaoTecnica.temaSelecionado.tema.nome
                    "
                    icon="bookmark"
                  />
                  <Label
                    class="col-12"
                    label="Valor estimado:"
                    :value="data.item.descricaoTecnica.valorEstimado"
                    icon="attach_money"
                  />
                </div>
              </div>
            </template>

            <template #cell(actions)="data">
              <div class="d-flex">
                <b-button
                  variant="flat-primary"
                  v-if="permissao.r"
                  @click="open(data.item)"
                >
                  <i class="fas fa-edit"></i>
                </b-button>
                <b-button
                  v-if="permissao.r"
                  variant="flat-danger"
                  @click="excluirProposta(data.item)"
                >
                  <i class="fa-solid fa-trash"></i>
                </b-button>
                <b-button
                  v-if="!data.item.aprovada && permissao.u"
                  class="ml-3"
                  :variant="`outline-${
                    data.item.congelada ? 'success' : 'danger'
                  }`"
                  size="sm"
                  @click="congelarProposta(data.item)"
                >
                  <i
                    :class="`fa-solid fa-${
                      data.item.congelada ? 'unlock' : 'lock'
                    } mr-2`"
                  ></i>
                  {{ data.item.congelada ? "Retomar" : "Congelar" }} proposta
                </b-button>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="tabela.paginaAtual"
            :total-rows="tabela.totalDeElementos"
            :per-page="tabela.porPagina"
            first-number
            @change="mudarPagina"
          ></b-pagination>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import Label from "@/components/inputs/Label";

import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import PropostaService from "@/common/services/proposta/proposta.service";
import helpers from "@/common/utils/helpers";

import Segmento from "@/common/mock/Segmento.json";
import TipoProduto from "@/common/mock/TipoProduto.json";

import { AlertasMixin } from "@/common/mixins/AlertasMixin";

export default {
  name: "PropostaLista",
  mixins: [AlertasMixin],
  components: {
    InputText,
    Label,
  },
  props: {
    endpoint: {
      type: String,
      default: "Proposta",
    },
    texto: {
      type: String,
      default: "Propostas",
    },
  },
  data: () => ({
    tabela: {
      colunas: [
        { key: "col1", label: "Propostas" },
        { key: "actions", label: "Ações" },
      ],
      items: [],
      porPagina: 10,
      paginaAtual: 1,
      totalDeElementos: 0,
    },
    options: {
      segmentos: Segmento,
      fases: helpers.FaseInovacao,
      tipoProdutos: TipoProduto,
    },
    filtro: "",
    empresas: [],
    empresasSelecionada: null,
  }),
  methods: {
    congelarProposta: function (item) {
      this.confirmar(
        `Deseja ${item.congelada ? "retomar" : "congelar"} a proposta?`
      ).then((confirmado) => {
        if (!confirmado) return;
        PropostaService.congelar(item.id, !item.congelada)
          .then(() => {
            this.alertaSucesso(
              `Proposta ${
                item.congelada ? "retomada" : "congelada"
              } com sucesso!`
            );
            item.congelada = !item.congelada;
          })
          .catch(() => {
            this.alertaErro(
              `Erro ao ${item.congelada ? "retomar" : "congelar"} proposta!`
            );
          });
      });
    },
    excluirProposta: function (item) {
      PropostaService.temMovimentacao(item.id)
        .then((response) => {
          let temMovimentacao = response.data.data;
          this.confirmar(
            temMovimentacao
              ? `Ocorreram movimentações nesta proposta. Se deseja seguir com a exclusão, clicar em SIM. Se deseja checar informações, clicar em NÃO.`
              : `Deseja seguir com a exclusão de prosposta?`
          ).then((confirmado) => {
            if (!confirmado) return;

            PropostaService.apagar(item.id)
              .then(() => {
                this.alertaSucesso(`Proposta excluída com sucesso!`).then(() =>
                  this.listar()
                );
              })
              .catch(() => {
                this.alertaErro(`Erro ao excluir proposta!`);
              });
          });
        })
        .catch(() => {
          this.alertaErro(`Náo é possível deletar porque já virou projeto.`);
        });
    },
    open: function (item) {
      if (!this.permissao.r) return;

      PropostaService.setEndpoint(item.endpoint);
      let rota = "";
      switch (item.endpoint) {
        case "Proposta":
          rota = "proposta-executora-detalhamento";
          break;
        case "PropostaEmpresaProponente":
          rota = "proposta-proponente-detalhamento";
          break;
        case "PropostaEmpresaExecutora":
          rota = "proposta-executora-associada-detalhamento";
          break;
        case "PropostaEmpresaCooperada":
          rota = "proposta-proponente-cooperada-detalhamento";
          break;
      }
      this.$router.push({ name: rota, params: { id: item.id } });
    },
    create: function () {
      this.$router.push({ name: "proposta-executora-formulario" });
    },
    onSearch: function (e) {
      e.preventDefault();
      this.listar(this.filtro);
    },
    mudarPagina: function (page) {
      this.listar(this.filtro, page);
    },
    async listar(filtro = "", page) {
      if (isNaN(page)) page = 1;
      if (!this.empresaSelecionada) return;

      const parametros = [
        this.empresaSelecionada.id,
        filtro,
        this.tabela.porPagina,
        page - 1,
      ];

      this.$store.dispatch(START_LOADING);

      PropostaService.listarPropostasAgrupadas(...parametros)
        .then((res) => {
          this.tabela.items = [];
          this.tabela.totalDeElementos =
            res.data.data.paginacao.totalDeElementos;
          this.tabela.items = res.data.data.itens.map((el) => {
            let id = el.id;
            let endpoint = el.endpoint;

            let newEl = el.proposta;
            newEl.idCongelar = el.proposta.id;
            newEl.id = id;
            newEl.endpoint = endpoint;
            newEl.descricaoTecnica.valorEstimado = helpers.formatarValor(
              newEl.descricaoTecnica.valorEstimado
            );

            return newEl;
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    retornarStatus: function (status) {
      return helpers.getEnum(status);
    },
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: this.texto }]);
    PropostaService.setEndpoint(this.endpoint);
    this.listar();
  },

  computed: {
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    empresaSelecionada() {
      return this.$store.state.app.selectedCompanyObj;
    },
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("Proposta");
    },
  },
  watch: {
    endpoint: function () {
      this.listar();
    },
    texto: function () {
      this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: this.texto }]);
    },
    "$store.state.app.selectedCompanyObj": {
      handler(newSelectedCompanyObj) {
        this.empresasSelecionada = newSelectedCompanyObj
          ? newSelectedCompanyObj
          : null;
        this.listar();
      },
      immediate: true,
    },
  },
};
</script>
<style lang=""></style>
